export const ANALYTICS_ID_PERSIST_DURATION = 24 * 60 * 360;
